import { render, staticRenderFns } from "./DeptRegLink.vue?vue&type=template&id=1657a706"
import script from "./DeptRegLink.vue?vue&type=script&lang=js"
export * from "./DeptRegLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports